/* Wellstore — scorrimento fluido della galleria al cambio variante.
 *
 * La galleria 1.5 seleziona il media per ID (il set mostrato può essere filtrato) e aggiorna lo stato
 * nativo. Lasciamo lavorare setActiveMedia e sostituiamo temporaneamente solo la sua slideTo a velocità
 * zero con una transizione da 400 ms: indice, fallback e stato della galleria restano nativi.
 * L'override viene applicato dopo la definizione dell'elemento custom.
 */
(function () {
  'use strict';

  customElements.whenDefined('media-gallery').then(function () {
    var MediaGallery = customElements.get('media-gallery');
    var originalSetActiveMedia = MediaGallery && MediaGallery.prototype.setActiveMedia;
    if (!originalSetActiveMedia || originalSetActiveMedia.__wsSmoothVariant) return;

    function setActiveMediaWithSmoothVariant(variant) {
      var slider = this.sliderInstance && this.sliderInstance.slider;
      var featuredMedia = variant && (variant.featured_media || variant.featured_image);
      if (!slider || !featuredMedia || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return originalSetActiveMedia.call(this, variant);
      }

      var hadOwnSlideTo = Object.prototype.hasOwnProperty.call(slider, 'slideTo');
      var nativeSlideTo = slider.slideTo;
      slider.slideTo = function (index, duration, runCallbacks) {
        if (duration === 0) {
          if (index === this.activeIndex) return false;
          duration = 400;
        }
        return nativeSlideTo.call(this, index, duration, runCallbacks);
      };

      try {
        return originalSetActiveMedia.call(this, variant);
      } finally {
        if (hadOwnSlideTo) {
          slider.slideTo = nativeSlideTo;
        } else {
          delete slider.slideTo;
        }
      }
    }

    setActiveMediaWithSmoothVariant.__wsSmoothVariant = true;
    MediaGallery.prototype.setActiveMedia = setActiveMediaWithSmoothVariant;
  });
})();
